<template>
  <div>
    <b-row>
      <b-col cols="3">
        <b-form inline>
          &nbsp;<input type="checkbox" v-model="allSelected" :disabled="filters.status == 'delivered'" />&nbsp;&nbsp;&nbsp;
          <font :size="fontSize">
            <span class="fas fa-sync-alt btn-edit" aria-hidden="true" title="Atualizar" @click="refreshTable()"
              style="cursor: pointer">
            </span>
          </font>
          &nbsp;&nbsp;&nbsp;
          <font :size="fontSize">
            <span>
              <action-menu-dropdown style="cursor: pointer" :usr_orders="usr_orders" :filters="filters"
                :expedition="expedition" :filtro="filtroIn"
                :items="items"></action-menu-dropdown>
            </span>
          </font>
        </b-form>
      </b-col>
    </b-row>
    <b-table v-scroll="handleScroll" class="box" show-empty empty-text="Sem registros para listar"
      empty-filtered-text="Nenhum registro encontrado" responsive striped small :items="items" :fields="fields"
      :current-page="currentPage" :per-page="perPage" :filter="filtro" @filtered="onFiltered" :busy="isBusy">
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner variant="success"></b-spinner>
          <strong variant="success">Carregando…</strong>
        </div>
      </template>

      <template #head(id)="scope"> </template>

      <template #head(created_by)="scope">
        <div class="text-nowrap text-left">Canal</div>
      </template>

      <template #head(sku)="scope">
        <div class="text-nowrap text-left">SKUs</div>
      </template>

      <template #head(external)="scope">
        <div class="text-nowrap text-left">IDs do pedido</div>
      </template>

      <template #head(created)="scope">
        <div class="text-nowrap text-center">Data de criação</div>
      </template>

      <template #head(payer_name)="scope">
        <div v-show="expedition === 'todos' || expedition === 'integracao_incorreta'" class="text-nowrap text-left">
          Nome completo
        </div>
      </template>

      <template #head(status)="scope">
        <div v-show="expedition == 'todos' || expedition === 'integracao_incorreta'" class="text-nowrap">
          Status
        </div>
      </template>

      <template #head(when_the_order_is)="scope">
        <div v-show="expedition == 'todos'"></div>
      </template>

      <template #head(total)="scope">
        <div v-show="expedition === 'todos'" class="text-nowrap">Total</div>
      </template>

      <template #head(sla)="scope">
        <div v-show="expedition === 'todos'" class="text-nowrap">SLA</div>
      </template>

      <template #head(observacao)="scope">
        <span v-show="expedition !== 'todos'">Observação</span>
      </template>

      <template #head(action)="scope">
        <div>Ações</div>
      </template>

      <template v-slot:cell(id)="data">
        <input type="checkbox" :id="data.item.id" :value="data.item.id"
          v-model="checkedOrders"
          :disabled="data.item.status == 'delivered'" />
      </template>

      <template v-slot:cell(created_by)="data">
        <div class="text-nowrap text-center">
          <font :size="fontSize">
            <ImgOnOff
              :url_file="`https://painel.plugg.to/assets/images/channels/${data.item.channel === '99 Compras' ? '5894b180e2a8c61c12f3a565407f53f2' : data.item.created_by_id}.svg`"
            />
            <br />
            <b-badge variant="info" style="cursor: default" class="mt-1">
              <span v-if="data.item.channel_account">
                <ReduceText
                  :objStringg="data.item.channel_account"
                  :descBool="true"
                />
              </span>
            </b-badge>
          </font>
        </div>
      </template>

      <template v-slot:cell(sku)="data">
        <font v-if="data.item.items.length" :size="fontSize">
          <span style="color: green" @click="data.item.show_all = !data.item.show_all">
            <!-- style="cursor: pointer" -->
            <i v-if="!data.item.show_all" class="fa fa-plus"></i>
            <i v-else class="fa fa-minus"></i>
          </span>
        </font>
        <font :size="fontSize" v-for="items in data.item.items" v-bind:key="items.id">
          <Sla :estimate_delivery_date="data.item.estimate_delivery_date" :before_status="data.item.before_status"
            :badge="false" :texto1="'SKU: ' + ofNull(items.sku)"
            :texto2="' <small>(' + ofNull(items.original_sku) + ')</small> '"
            :texto3="' Nome: ' + ofNull(items.name) + ' '" :show_all="data.item.show_all" /><br />
        </font>
        <font :size="fontSize">
          {{ `Quantidade: ${sumSkuquantity(data.item.items)}` }}
        </font>
      </template>

      <template v-slot:cell(external)="data">
        <div class="text-left">
          <font :size="fontSize">
            <span v-for="i in transformExternal(data.item.external)" :key="i.app">
              <b-badge variant="secondary" style="cursor: default" v-b-tooltip.hover.bottom="i.app" class="mt-1">
                {{ parseID(i.external) }}
              </b-badge>
              <br />
            </span>
          </font>
        </div>
      </template>

      <template v-slot:cell(created)="data">
        <div class="text-center">
          <font :size="fontSize">
            <Sla :estimate_delivery_date="data.item.estimate_delivery_date" :before_status="data.item.before_status"
              :badge="false" :texto="data.item.created + 'h'" />
          </font>
        </div>
      </template>

      <template v-slot:cell(payer_name)="data">
        <div v-show="expedition === 'todos' || expedition === 'integracao_incorreta'" class="text-left">
          <font :size="fontSize">
            <Sla :estimate_delivery_date="data.item.estimate_delivery_date" :before_status="data.item.before_status"
              :badge="false" :texto="data.item.payer_name" />
          </font>
        </div>
      </template>

      <template v-slot:cell(total)="data">
        <div v-show="expedition === 'todos'">
          <font :size="fontSize">
            <Sla :estimate_delivery_date="data.item.estimate_delivery_date" :before_status="data.item.before_status"
             :badge="false" :texto="Array.isArray(data.item.total) && data.item.total[0] ? data.item.total[0] : 0"
/>
              <br>
              <b-badge v-for="(method, index) in data.item.total[1]"
                :key="index"
                :title="method"
                :variant="formatStatusBadgeMethod(method)"
                :style="{ marginRight: '7px' }">
                {{ method }}
              </b-badge>
          </font>
        </div>
      </template>

      <template v-slot:cell(status)="data">
        <div v-show="expedition === 'todos' || expedition === 'integracao_incorreta'">
          <font :size="fontSize">
            <b-badge style="cursor: default" :variant="formatStatusBadge(data.item.status)">
              &nbsp;{{ data.item.status || $t("Sem informação") }}&nbsp; </b-badge><br />
            <b-badge style="cursor: default" v-show="data.item.status === 'Cancelado' && !!data.item.sub_status" variant="secondary">
              &nbsp;{{ data.item.sub_status }}&nbsp;
            </b-badge>
            <b-badge v-show="data.item.shipments && data.item.shipments[0] && data.item.shipments[0].status === 'buffered'" variant="warning" style="cursor: default" v-b-tooltip.hover.bottom="'Aguardando liberação do marketplace.'">
              &nbsp;Aguardando Etiqueta &nbsp;
            </b-badge>
            <!-- Dispute flags -->
            <b-badge v-show="data.item.sub_status === 'Disputa aberta'" variant="warning" style="cursor: default" v-b-tooltip.hover.bottom="'Disputa aberta pelo cliente no marketplace.'">
              &nbsp;Disputa aberta&nbsp;
            </b-badge>
            <b-badge v-show="data.item.sub_status === 'Disputa em andamento'" variant="warning" style="cursor: default" v-b-tooltip.hover.bottom="'Disputa sendo processada pelo marketplace.'">
              &nbsp;Disputa em andamento&nbsp;
            </b-badge>
            <b-badge v-show="data.item.sub_status === 'Disputa finalizada'" variant="secondary" style="cursor: default" v-b-tooltip.hover.bottom="'Disputa resolvida.'">
              &nbsp;Disputa finalizada&nbsp;
            </b-badge>
          </font>
        </div>
      </template>

      <template v-slot:cell(when_the_order_is)="data">
        <font v-show="expedition == 'todos'" :size="fontSize">
          <WhenTheOrderIs :invoicing_accepted="data.item.invoicing_accepted"
            :shipping_accepted="data.item.shipping_accepted" :delivery_accepted="data.item.delivery_accepted"
            :status="data.item.before_status" />
          <DeliveryType :tag="data.item.delivery_type" />
          <BadgeInfo :infos="getGenericInfos(data)" />
        </font>
      </template>

      <template v-slot:cell(sla)="data">
        <div v-show="expedition === 'todos'" v-if="
          data.item.before_status !== 'delivered' &&
          data.item.before_status !== 'canceled'
        ">
          <font :size="fontSize">
            <Sla :estimate_delivery_date="data.item.estimate_delivery_date" :before_status="data.item.before_status"
              :badge="true" :texto="data.item.expected_send_date" />
          </font>
        </div>
      </template>

      <template v-slot:cell(observacao)="data">
        <span v-show="expedition !== 'todos'" v-if="data.item.observacao[0]">
          <font :size="fontSize">
            <ReduceText :objStringg="data.item.observacao[data.item.observacao.length - 1].message" :descBool="true" />
          </font>
        </span>
      </template>

      <template v-slot:cell(action)="data">
        <b-button variant="btn btn-edit btn-sm" @click="edit(data.item)">
          <i class="fas fa-pencil-alt"></i>
        </b-button>
        <Etiqueta v-if="
          data.item.tags.has_label === 0 ||
          data.item.tags.has_label === 1 ||
          data.item.tags.has_label === 2
        " :item="data.item" />
        <Nfe v-if="
          checkFaturador &&
          data.item.shipments.length &&
          data.item.status !== 'Erro ao gerar nota fiscal'
" :documents="data.item.shipments[0].documents" :item="data.item" :checkFaturador="checkFaturador" />
      </template>
    </b-table>
    <b-row>
      <b-col class="text-center">
        <span v-if="endItems"> Fim, não tem mais pedidos para listar.</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-center">
        <div v-if="loadSmallg" class="text-center text-success my-2">
          <b-spinner variant="success"></b-spinner><br />
          <strong variant="success">Carregando mais pedidos...</strong>
        </div>
      </b-col>
    </b-row>
    <br />
  </div>
</template>

<script>
import ActionMenuDropdown from "./ActionMenuDropdown/ActionMenuDropdown.vue";
import { AppService } from "../../../services/appService";
import WhenTheOrderIs from "./WhenTheOrderIs.vue";
import DeliveryType from "./DeliveryType.vue";
import BadgeInfo from "./BadgeInfo.vue";
import barramento from "../../../barramento";
import ReduceText from "./ReduceText.vue";
import ImgOnOff from "./ImgOnOff.vue";
import Etiqueta from "./Etiqueta.vue";
import moment from "moment";
import Sla from "./Sla.vue";
import Nfe from "./Nfe.vue";
import axios from "axios";
export default {
  name: "Tables",
  props: [
    "filters",
    "url",
    "url_next",
    "expedition",
    "checkFaturador",
    "usr_orders",
    "showAll",
    "apps",
  ],
  components: {
    ActionMenuDropdown,
    WhenTheOrderIs,
    DeliveryType,
    BadgeInfo,
    Sla,
    Etiqueta,
    Nfe,
    ReduceText,
    ImgOnOff,
  },
  data() {
    return {
      isBusy: false,
      fontSize: 2,
      fields: [
        { key: "id", label: "" },
        { key: "created_by", label: "Canal" },
        { key: "sku", label: "SKUs" },
        { key: "external", label: "IDs do pedido" },
        { key: "created", label: "Data de criação" },
        { key: "payer_name", label: "Nome completo" },
        { key: "total", label: "Total" },
        { key: "status", label: "Status" },
        { key: "when_the_order_is", label: "" },
        { key: "sla", label: "SLA" },
        { key: "observacao", label: "Observação" },
        { key: "action", label: "Ações" },
      ],
      scrollD: 2100,
      items: [],
      currentPage: 1,
      totalRows: 0,
      perPage: 50,
      filtro: null,
      filtroIn: null,
      allSelected: false,
      checkedOrders: [],
      loadSmallg: false,
      endItems: false,
      previousCount: 0,
      beforeMountCount: 0,
    };
  },
  watch: {
    allSelected: {
      handler(newValue, oldValue) {
        this.checkedOrders = [];
        if (newValue) {
          for (var i in this.items) {
            this.checkedOrders.push(this.items[i].id);
          }
        }
      },
      deep: true,
    },
  },
  provide() {
    return {
      getSelectedOrderIds: this.getSelectedOrderIds,
      clearSelectedOrders: this.clearSelectedOrders
    };
  },
  methods: {
    getSelectedOrderIds() {
      // Retorna cópia do array de IDs selecionados do v-model
      // Usa spread para criar snapshot imediato, evitando modificações posteriores
      return [...this.checkedOrders];
    },
    clearSelectedOrders() {
      // Limpa a seleção resetando o model
      this.checkedOrders = [];
      this.allSelected = false;
    },
    edit(item) {
      barramento.$emit("order_edit", { item: item, apps: this.apps });
    },
    sumSkuquantity(items) {
      var quantity = 0;
      for (var i in items) {
        quantity += items[i].quantity;
      }
      return quantity;
    },
    transformExternal(object) {
      let arr = [];
      if (object && typeof object === "object") {
        for (let key in object) {

          var app_name = key;
          for (var i in this.apps)
            if (this.apps[i].client_id == key)
              app_name = this.apps[i].name;

          arr.push({
            app: app_name,
            external: object[key],
          });

        }
      }
      return arr;
    },
    parseID(external) {
      if (external && typeof external === "string") {
        let match = external.match(",");
        if (match && match.index) {
          return external.slice(0, match.index) + "...";
        }
      }

      return external;
    },
    checkEtiqueta(status) {
      switch (status) {
        case "approved":
        case "invoiced":
        case "shipping_informed":
        case "shipping_error":
          return true;
        default:
          return false;
      }
    },
    toggleBusy: function () {
      this.isBusy = !this.isBusy;
    },
    parseDate(dateString) {
      if (typeof dateString === "string") {
        dateString = dateString.replace("T", " ");
        dateString = dateString.replace(".000Z", "");
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        const horas = date.getHours().toString().padStart(2, "0");
        const minutos = date.getMinutes().toString().padStart(2, "0");
        return `${day}/${month}/${year} às ${horas}:${minutos}h`;
      }
      return dateString;
    },
    formatDate(value, loc = null) {
      if (value) {
        if (loc !== "US") {
          let date = moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
          if (date === "Invalid date") {
            return value;
          }
          return date;
        } else {
          return moment(String(value)).format("YYYY-MM-DD HH:mm:ss");
        }
      }
    },
    formatCurrency(value, payments) {
      let paymentMethods = payments
        ? [...new Set(payments
            .filter(payment => payment && payment.payment_method)
            .map(payment => {
              return this.$t(payment.payment_method).charAt(0).toUpperCase() + this.$t(payment.payment_method).slice(1);
            })
          )]
        : [];

      let total = value ? Intl.NumberFormat("pt-br", {
        currency: "BRL",
        style: "currency",
      }).format(value) : 0;

      return [total, paymentMethods];
    },
    formatStatusBadgeMethod(method) {
      let color;
      switch (method) {
        case "Credit_card":
        case "CreditCard":
        case "Credit Card":
          color = "primary";
          break;
        case "Credito":
          color = "success";
          break;
        case "Boleto":
          color = "danger";
          break;
        case "Pix":
          color = "warning";
          break;
        default:
          color = "dark";
      }
      return color;
    },
    formatStatusBadge(stats) {
      if (stats === undefined || stats == null) {
        return "";
      }
      let status = stats.toLowerCase();
      switch (status) {
        case "pendente":
          return "info";
        case "aprovado":
          return "success";
        case "faturado":
          return "primary";
        case "erro ao gerar nota fiscal":
        case "erro ao enviar entrega":
          return "danger";
        case "cancelado":
          return "dark";
        default:
          return "primary";
      }
    },
    formatSubStatusText(sub_status) {
      if (sub_status === undefined || sub_status == null) {
        return "";
      }
      switch (sub_status) {
        case "returned":
          return "Devolvido";
        case "lost":
          return "Extraviado";
        case "requested_dispute":
          return "Disputa aberta";
        case "processing_dispute":
          return "Disputa em andamento";
        case "finished_dispute":
          return "Disputa finalizada";
      }
    },
    formatStatusText(status) {
      if (status === undefined || status == null) {
        return "";
      }
      switch (status) {
        case "approved":
          return "Aprovado";
        case "picking":
          return "Em separação";
        case "delivered":
          return "Entregue";
        case "in_transit":
          return "Em transito";
        case "invoiced":
          return "Faturado";
        case "shipped":
          return "Enviado";
        case "canceled":
          return "Cancelado";
        case "invoice_error":
          return "Erro ao gerar nota fiscal";
        case "shipping_error":
          return "Erro ao enviar entrega";
        case "pending":
          return "Pendente";
        case "partial_payment":
          return "Pagamento parcial";
        case "shipping_informed":
          return "Envio informado";
        case "waiting_invoice":
          return "Nota fiscal solicitada";
        case "requested_dispute":
          return "Disputa aberta";
        case "processing_dispute":
          return "Disputa em andamento";
        case "finished_dispute":
          return "Disputa finalizada";
        default:
          return status;
      }
    },
    getGenericInfos(data) {
      const itens = [];
      let hasBuffered = false;

      for (let key in data.shipments) {
        const shipment = data.shipments[key];
        if (shipment.status == "buffered") {
            hasBuffered = true;
        }
      }
      if (hasBuffered) {
        itens.push({
          title: "Aguardando liberação",
          status: "danger"
        });
      }
      return itens;
    },
    getAppNameByClientID(clientID) {
      if (clientID) {
        return AppService.getNameOfAppByClientID(clientID);
      }
    },
    refreshTable() {
      this.setFilter(this.filtroIn);
    },
    setFilter(filters) {
      this.items = [];
      this.scrollD = 2100;
      var f = filters;
      if (!f) f = this.filters;
      this.getOrders(this.url, true, false, f);
    },
    ofNull(n = null) {
      if (n) return n;
      return "";
    },
    getEstimateDeliveryDate(shipments) {
      if (shipments.length) {
        return shipments[0].estimate_delivery_date;
      }
      return null;
    },
    onFiltered: function (filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    handleScroll: function (evt, el) {
      var scrollY = window.pageYOffset;

      if (this.loadSmallg === false && this.endItems == false && scrollY > this.scrollD) {
        this.nextGetOrders();
        this.scrollD = scrollY + 200;
      }
    },
    nextGetOrders: function () {
      let lastItem;

      if (this.items && this.items.length > 0)
        lastItem = this.items[this.items.length - 1];

      if (typeof lastItem == "undefined") return;

      this.loadSmallg = true;
      this.perPage = this.perPage + 50;

      let object1 = this.filtroIn;
      let newObj = this.filters;

      if (object1 !== null) {
        Object.keys(object1).forEach((prop) => {
          if (object1[prop]) newObj[prop] = object1[prop];
        });
      }

      this.getOrders(this.url_next + lastItem.id, false, true, newObj);
    },
    getOrders: function (
      url,
      loagindTable = false,
      loadSmallg = false,
      f = null,
      beforeMountCount = false
    ) {

      if (loagindTable) this.toggleBusy();

      var filterPort = this.filters;
      if (f) filterPort = f;

      var filterPortRequest = filterPort;
      if (this.expedition === "integracao_incorreta" && url.includes("next")) {
        filterPortRequest = {
          ordersError: filterPort,
        };
      }

      axios.post(url, filterPortRequest).then((response) => {
        var orders = [];
        orders = !!response.data.orders ? response.data.orders : response.data;

        if (orders.length < 50) this.endItems = true;
        else this.endItems = false;

        for (var i = 0; i < orders.length; i++) {
          var r = null;
          r = this.items.find((fruit) => fruit.id === orders[i].id);
          if (!r) {
            this.items.push({
              id: orders[i].id,
              created_by_id: orders[i].created_by,
              created_by: this.getAppNameByClientID(orders[i].created_by),
              channel: orders[i].channel,
              channel_account: orders[i].channel_account,
              created: this.formatDate(orders[i].created),
              external: orders[i].external,
              user_id: orders[i].user_id,
              payer_name:
                this.ofNull(orders[i].payer_name) +
                " " +
                this.ofNull(orders[i].payer_lastname),
              metodo_etiqueta: null,
              metodo_envio: null,
              impressao: null,
              observacao: orders[i].log_history,
              items: orders[i].items,
              total: this.formatCurrency(orders[i].total, orders[i].payments),
              status: this.formatStatusText(orders[i].status),
              sub_status: this.formatSubStatusText(orders[i].sub_status),
              before_status: orders[i].status,
              expected_send_date: this.parseDate(orders[i].expected_send_date),
              before_expected_send_date: orders[i].expected_send_date,
              estimate_delivery_date: this.getEstimateDeliveryDate(orders[i].shipments),
              tags: orders[i].tags,
              shipments: orders[i].shipments,
              before: orders[i],
              invoicing_accepted: orders[i].invoicing_accepted,
              shipping_accepted: orders[i].shipping_accepted,
              delivery_accepted: orders[i].delivery_accepted,
              delivery_type: orders[i].delivery_type,
              show_all: false,
            });
          }
        }
        this.totalRows = this.items.length;
        if (loagindTable) this.toggleBusy();
        if (loadSmallg) this.loadSmallg = false;
        if (beforeMountCount) this.beforeMountCount = response.data.total;
        if (!!response.data.total) this.previousCount = response.data.total;
        if (
          !response.data.total &&
          !!response.data.length &&
          this.previousCount < this.beforeMountCount
        )
          this.previousCount = this.previousCount + response.data.length;
        if (this.expedition == "todos") {
          barramento.$emit("action_props_totos", {
            items: this.items,
            value: null,
            applyFilter: null,
            loadTotalOrders: null,
            filters: this.filters,
          });
        }

        barramento.$emit("count_" + this.expedition, {
          valor: this.previousCount,
          expedition: this.expedition,
        });
      });
    },
  },
  beforeMount() {
    this.getOrders(this.url, true, false, null, true);
  },
  beforeDestroy() {
    barramento.$off(this.expedition);
  },
  created() {
    barramento.$on(this.expedition, (filters) => {
      this.filtroIn = filters;
      this.setFilter(filters);
    });
  },
};
</script>

<style>
.box {
  transition: 1.5s all cubic-bezier(0.39, 0.575, 0.565, 1);
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/Tables.vue